let links = [
    {
        "name": "Витамин А, РЭ",
        "link": "/blog/post/vitamin-a-polza-vred-nedostatok-norma-luchshie-istochniki-vitamina-a"
    },
    {
        "name": "Витамин В1, тиамин",
        "link": "/blog/post/vitamin-b1-zachem-on-nuzhen-i-gde-ego-iskat"
    },
    {
        "name": "Витамин В2, рибофлавин",
        "link": "/blog/post/vitamin-b2-polza-vred-i-norma-upotrebleniya-spisok-produktov"
    },
    {
        "name": "Витамин В4, холин",
        "link": "/blog/post/vitamin-b4-poleznoe-i-vrednoe-deficit-i-norma-produkty-soderzhashchie-kholin"
    },
    {
        "name": "Витамин В6, пиридоксин",
        "link": "/blog/post/vitamin-b6-polza-i-vred-norma-potrebleniya-i-istochniki-v-pitani"
    },
    {
        "name": "Витамин В5, пантотеновая",
        "link": "/blog/post/vitamin-b5-polza-i-vred-norma-potrebleniya-i-produkty-istochniki"
    },
    {
        "name": "Витамин В12, кобаламин",
        "link": "/blog/post/vitamin-b12-polyza-vred-istochniki-v-pitani"
    },
    {
        "name": "Витамин D, кальциферол",
        "link": "/blog/post/vitamin-d-polza-vred-norma-i-kak-poluchit-ego-iz-produktov-pitaniya-i-dobavok"
    },
    {
        "name": "Витамин В9, фолаты",
        "link": "/blog/post/vitamin-b9-polza-i-vred-istochniki-i-normy-potrebleniya"
    },
    {
        "name": "Витамин C, аскорбиновая",
        "link": "/blog/post/vitamin-c-polza-i-vred-normy-potrebleniya-i-produkty-s-vysokim-soderzhaniem"
    },
    {
        "name": "Витамин Е, альфа токоферол, ТЭ",
        "link": "/blog/post/vitamin-e-polza-i-vred-dlya-zdorovya-organizma"
    },
    {
        "name": "Витамин К, филлохинон",
        "link": "/blog/post/vitamin-k-polza-i-vred-proyavleniya-defitsita-normy-i-istochniki-v-pitaniyi"
    },
    {
        "name": "Витамин РР, НЭ",
        "link": "/blog/post/vitamin-pp-polza-norma-potrebleniya-i-istochniki"
    },
    {
        "name": "Витамин Н, биотин",
        "link": "/blog/post/biotin-polza-norma-potrebleniya-istochniki"
    },
    {
        "name": "Ниацин",
        "link": "/blog/post/vitamin-b3-polza-i-vred-norma-potrebleniya-produkty-istochniki"
    },
    {
        "name": "Ванадий, V",
        "link": "/blog/post/vanadiy-v-organizme-cheloveka-polza-i-vred-norma-potrebleniya-i-istochniki"
    },
    {
        "name": "Йод, I",
        "link": "/blog/post/zdravie-organizma-i-iod-normy-potrebleniya"
    },
    {
        "name": "Витамин D3, холекальциферол",
        "link": "/blog/post/d3-polyza-i-norma-upotrebleniya-istochniki-i-defitsit"
    },
    {
        "name": "Кремний, Si",
        "link": "/blog/post/kremniy-polza-i-vred-dlya-zdorovya-cheloveka-norma-potrebleniya-i-produkty-bogatye-etim-elementom"
    },
    {
        "name": "Титан, Ti",
        "link": "/blog/post/vazhnost-titana-dlya-organizma-cheloveka-polza-nedostatok-i-produkty-s-vysokim-soderzhaniem-titana"
    },
    {
        "name": "Кобальт, Co",
        "link": "/blog/post/vazhnost-kobalta-dlya-zdorovya-cheloveka-polza-i-vred-norma-potrebleniya-i-produkty-istochniki"
    },
    {
        "name": "Литий, Li",
        "link": "/blog/post/mikroelement-litiy-v-organizme-cheloveka"
    },
    {
        "name": "бета Каротин",
        "link": "/blog/post/beta-karotin-polza-vred-norma"
    },
    {
        "name": "Витамин Н, биотин",
        "link": "/blog/post/mikroelement-litiy-v-organizme-cheloveka"
    },
    {
        "name": "",
        "link": ""
    },
    {
        "name": "Калий, K",
        "link": "/blog/post/kalij-polza-i-vred-norma-potrebleniya-produkty-bogatye-kaliem"
    },
    {
        "name": "Кальций, Ca",
        "link": "/blog/post/calcium-benefit-harm-norms-foods"
    },
    {
        "name": "Магний, Mg",
        "link": "/blog/post/vazhnost-magniya-dlya-zdorovya-polza-i-vred-norma-potrebleniya-i-produkty-s-vysokim-soderzhaniem"
    },
    {
        "name": "Натрий, Na",
        "link": "/blog/post/natrij-polsa-i-vred-norma-potrebleniya-produkty-istochniki"
    },
    {
        "name": "Сера, S",
        "link": "/blog/post/vazhnost-sery-dlya-zdorovya"
    },
    {
        "name": "Фосфор, P",
        "link": "/blog/post/fosfor-poleznoe-i-vrednoe-norma-i-produkty-s-vysokim-soderzhaniem"
    },
    {
        "name": "Хлор, Cl",
        "link": "/blog/post/vazhnost-hlora-dlya-zdorovya-polza-i-vred-norma-i-istochniki"
    },
    {
        "name": "Алюминий, Al",
        "link": "/blog/post/aluminij-v-organizme-cheloveka-polza-i-vred-norma-potrebleniya-produkty-s-vysokim-soderzhaniem"
    },
    {
        "name": "Бор, B",
        "link": "/blog/post/vazhnost-mikroelementa-bora-dlya-zdorovya-cheloveka"
    },
    {
        "name": "Ретинол",
        "link": "/blog/post/retinol-polza-normy-potrebleniya-i-istochniki"
    },
    {
        "name": "Витамин D2, эргокальциферол",
        "link": "/blog/post/vitamin-d2-polezno-i-vred"
    },
    {
        "name": "бета Токоферол",
        "link": ""
    },
    {
        "name": "гамма Токоферол",
        "link": ""
    },
    {
        "name": "Бетаин",
        "link": "/blog/post/vse-chto-nuzhno-znat-o-betaine-polza-i-norma-potrebleniya"
    },
    {
        "name": "Цирконий, Zr",
        "link": "/blog/post/mikroelement-tsirkoniy-v-organizme-cheloveka-polza-vred-i-normy-potrebleniya"
    },
    {
        "name": "бета Криптоксантин",
        "link": "/blog/post/beta-kriptoksantin-polza-i-vred-norma-i-produkty-bogatye-etim-karotinoidom"
    },
    {
        "name": "Лютеин + Зеаксантин",
        "link": "/blog/post/lutein-zeaxanthin-polza-vred-norma-produkty"
    },
    {
        "name": "альфа Каротин",
        "link": "/blog/post/alpha-karotin-polza-vred-norma-produtky-istochniki"
    },
    {
        "name": "Ликопин",
        "link": "/blog/post/lycopene-polza-i-vred-norma-dlya-muzhchin-zhenshchin-i-detey-istochniki-v-pitani"
    },
    {
        "name": "дельта Токоферол",
        "link": ""
    },
    {
        "name": "Молибден, Mo",
        "link": "/blog/post/molibden-polza-i-vred-norma-i-istochniki"
    },
    {
        "name": "Никель, Ni",
        "link": "/blog/post/nickel-v-organizme-cheloveka-polza-i-vred-norma-produkty"
    },
    {
        "name": "Рубидий, Rb",
        "link": "/blog/post/rubidiy-v-organizme-cheloveka-polza-i-vred-normy-i-produkty"
    },
    {
        "name": "Стронций, Sr",
        "link": "/blog/post/strontsiy-v-organizme-cheloveka-polza-i-vred-norma-i-defitsit"
    },
    {
        "name": "Фтор, F",
        "link": "/blog/post/ftor-polezha-i-vred-norma-potrebleniya-i-produkty-bogatye-ftorom"
    },
    {
        "name": "Хром, Cr",
        "link": "/blog/post/vse-o-hrome-polza-i-vred-norma-potrebleniya-i-luchshie-istochniki"
    },
    {
        "name": "Железо, Fe",
        "link": "/blog/post/zhelezo-v-pitaniya-polza-norma-potrebleniya-i-produkty-istochniki"
    },
    {
        "name": "Марганец, Mn",
        "link": "/blog/post/manganec-polezno-i-vred-dlya-organizma"
    },
    {
        "name": "Медь, Cu",
        "link": "/blog/post/med-polsa-i-vred-norma-produkty-i-defitsit"
    },
    {
        "name": "Селен, Se",
        "link": "/blog/post/selen-polza-i-vred-norma-potrebleniya-produkty"
    },
    {
        "name": "Цинк, Zn",
        "link": "/blog/post/zinc-polezno-i-vred-norma-potrebleniya-i-produkty-istochniki"
    }
]

export const getLink = (name) => {
    let result = links.find((item) => {
        return item.name === name
    })

    if (result && result.link !== "") {
        return result.link
    }

    return ""
}
